import { Injectable } from "@angular/core";
import { CtWebapiService, DataRequest } from "@ctsolution/ct-webapi";
import { Observable } from "rxjs";
import { CtWebapiGenericResponse } from "@ctsolution/ct-webapi/core/response.interface";
import { AddressBookParameter } from "../classes/address-book.parameter";
import { AddressBookListResponse, AddressBookResponse } from "../interfaces/address-book-response";

@Injectable()
export class AddressBookController {

  private controller: string = "/AddressBook/";

  constructor(private _webapi: CtWebapiService) {
  }

  addressBookList(parameter: AddressBookParameter | null = null): Observable<CtWebapiGenericResponse<AddressBookListResponse>> {

    const request: DataRequest = new DataRequest(`${this.controller}AddressBookList`);

    if (parameter) {

      request
        .setQueryParams(parameter);

    }

    return this._webapi
      .get(request);

  }

  save(parameter: AddressBookParameter) {

    const request: DataRequest = new DataRequest(`${this.controller}Save`)
      .setBody(parameter);

    return this._webapi
      .post(request);

  }

  delete(parameter: AddressBookParameter) {

    const request: DataRequest = new DataRequest(`${this.controller}Delete`)
      .setQueryParams(parameter);

    return this._webapi
      .delete(request);

  }

  addressBookDetail(parameter: AddressBookParameter) {

    const request: DataRequest = new DataRequest(`${this.controller}Detail`)
      .setQueryParams(parameter);

    return this._webapi
      .get(request);


  }

}



